import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffbb7c76&"
import script from "./index.vue?vue&type=script&scoped=true&lang=js&"
export * from "./index.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports